export default "__VITE_ASSET__U1Ls9qOa__"